<template>
  <div class="my" :class="{ 'my not-expanded': !expanded }">
    <header class="my-header">
      <span
        v-if="from_date || to_date"
        @click="deleteValue"
        class="my-header-icon-remove filter-trash cursor_pointer"
      >
        <mdicon name="trash-can-outline" size="18" />
      </span>
      <p @click="toggleCardState" class="my-header-title pl-1">
        <span
          class="text-primary pr-1"
          :class="{ 'ml-4': from_date || to_date }"
          v-b-tooltip.hover
          :title="header.search_scope"
        >
          <mdicon
            v-if="header.search_scope"
            name="information"
            class="information-icon"
            size="20"
          />
          <mdicon v-else name="checkbox-blank-circle-outline" size="20" />
        </span>
        <span class="pr-1">
          {{ header.key_filter_caption }}
        </span>
      </p>
      <a @click="toggleCardState" class="my-header-icon">
        <span class="icon">
          <i class="fa fa-angle-up"></i>
        </span>
      </a>
    </header>

    <div class="my-content">
      <div class="content p-2">
        <b-form-group label-for="timeing" :label-cols="$config.form.labelCol">
          <selectFind
            :options="timeing_options"
            v-model="timeing_selected"
            label="text"
            id="value"
            :loading="timeing_Loading"
            @input="changingStructure"
          />
        </b-form-group>
        <b-form-group
          :label="generateDateLabel($lang.start)"
          label-for="credit_end_date"
          :label-cols="12"
        >
          <date-picker
            :type="header.type"
            v-model="from_date"
            :display-format="
              header.type !== `datetime`
                ? `jYYYY/jMM/jDD`
                : `jYYYY/jMM/jDD HH:mm`
            "
            :format="
              header.type !== `datetime` ? `YYYY/MM/DD` : `YYYY/MM/DD HH:mm`
            "
            inputReq="true"
            clearable
            auto-submit
            @input="changeDate"
          >
          </date-picker>
        </b-form-group>
        <b-form-group
          v-if="timeing_selected && timeing_selected.value == `between`"
          :label="generateDateLabel($lang.end)"
          label-for="credit_end_date"
          :label-cols="12"
        >
          <date-picker
            :type="header.type"
            v-model="to_date"
            inputReq="true"
            :display-format="
              header.type !== `datetime`
                ? `jYYYY/jMM/jDD`
                : `jYYYY/jMM/jDD HH:mm`
            "
            :format="
              header.type !== `datetime` ? `YYYY/MM/DD` : `YYYY/MM/DD HH:mm`
            "
            clearable
            auto-submit
            @input="changeDate"
          >
          </date-picker>
        </b-form-group>
        <button
          v-if="timeing_selected && timeing_selected.value == `between`"
          class="btn btn-primary w-100 my-2"
          @click="actionBetween"
        >
          {{ $lang.btn_date }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { pathOr } from "ramda";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    expandAll: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    header: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      result: this.value,
      expanded: false,
      from_date: null,
      to_date: null,

      timeing_selected: {
        value: "eq",
        text: " مساوی",
      },
      timeing_Loading: false,
      timeing_options: [
        {
          value: "eq",
          text: " مساوی",
        },
        {
          value: "between",
          text: "مابین",
        },
        {
          value: "gt",
          text: "بزرگتر ",
        },
        {
          value: "lt",
          text: "کوچکتر",
        },
        {
          value: "gte",
          text: "بزرگتر مساوی",
        },
        {
          value: "lte",
          text: "کوچکتر مساوی",
        },
      ],
    };
  },
  methods: {
    pathOr,
    toggleCardState() {
      this.expanded = !this.expanded;
      if (this.expanded) this.$emit("getData", this.header);
    },
    closeAll() {
      this.expanded = false;
    },
    changingStructure() {
      if (
        (this.from_date || this.to_date) &&
        this.timeing_selected !== "between"
      )
        this.$emit(
          "dateSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_date,
          this.to_date
        );
    },
    actionBetween() {
      if (this.from_date && this.to_date)
        this.$emit(
          "dateSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_date,
          this.to_date
        );
      else this.$notify.error(this.$lang.error_date_between);
    },
    changeDate() {
      if (this.from_date && this.timeing_selected.value !== "between") {
        this.$emit(
          "dateSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_date,
          this.to_date
        );
      }
    },
    deleteValue() {
      this.from_date = "";
      this.to_date = "";
      this.timeing_selected = {
        value: "eq",
        text: " مساوی",
      };
      this.$emit(
        "dateSelected",
        this.header.key_service,
        this.timeing_selected.value,
        this.from_date,
        this.to_date
      );
    },
    fetchData() {
      if (this.result.length > 0) {
        const timeing = this.result[0];
        this.from_date = this.result[1];
        this.to_date = this.result[2];
        this.timeing_selected = this.timeing_options.find(
          (x) => x.value == timeing
        );
      }
    },
    clearAllData() {
      this.restult = [];
      this.from_date = "";
      this.to_date = "";
      this.closeAll();
    },

    generateDateLabel(flag) {
      const type = pathOr(null, ["type"], this.header);
      const timingSelected = pathOr(null, ["value"], this.timeing_selected);
      const first = type === "date" ? this.$lang.date : this.$lang.date_time;
      const output = timingSelected === "between" ? `${first} ${flag}` : first;
      return output;
    },
  },
  created() {
    this.$on("closeAll", this.closeAll);
    this.fetchData();
  },
};
</script>
